import { apiClient } from "../../utils/apiClient";
import { Permission } from "../../types/permission";
import { permissionsList } from "../../types/permissionsList";

export const fetchPermissions = async (): Promise<Permission[]> => {
    const response = await apiClient.get('/permissions');
    return response.data;
};

export const upsertPermission = async (permission: Permission): Promise<Permission> => {
    const response = await apiClient.post('/permissions', permission);
    return response.data;
};

export const getPermissionByUserNameOrRole = async (username: string, role: string): Promise<permissionsList[] | null> => {
    try {
        const response = await apiClient.get(`/permissions/user-role-permissions?ad_username=${username}&role_name=${role}`);
        return response.data;
    } catch (error: any) {
        if (error.response && error.response.status === 404) {
            return null; // No permission found
        }
        throw error; // Re-throw other errors
    }
};